<section class="flex justify-content-center mt-4 wrapper-content flex-column">
  <div class="inline-flex justify-content-between align-items-stretch md:align-items-center w-full flex-column md:flex-row">
    <div>
      <h2 class="title-blue font-roboto-condensed font-23 font-normal uppercase">{{translations.titulo}}</h2>
    </div>
    <div>
      <div class=" border-gradient flex" style="height:50px;">
        <div class="input-text inline-flex md:border-none w-full">
          <div class="flex align-items-center justify-content-center ml-1 ">
            <img class="icon" alt="icon search" src="assets/img/icons-principal/ico-search.svg">
          </div>
          <input type="text" class="input-text-gray w-full border-none font-16 font-normal" pInputText
                 [(ngModel)]="numeroRadicado" [placeholder]="translations.tuTramite" (keydown.enter)="search()"/>
        </div>
        <div class="inline-flex gap-1 mr-1 align-items-center">
          <button pButton class="p-button-rounded p-button-icon-only p-button-text" *ngIf="numeroRadicado?.length">
            <i class="pi pi-times text-blue-general" (click)="search(true)"></i>
          </button>
          <button pButton class="p-button-rounded p-button-icon-only " (click)="search()">
            <svg-loader name="ico-normal-tramitfly-white"/>
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class=" col-12">
		<div class="flex flex-column align-items-center gap-3">

			<p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
				<p-tabPanel [header]="translations.header">
					<app-tramites-por-estado [radicado]="radicado"
                                   [title]="translations.header"/>
				</p-tabPanel>
				<p-tabPanel [header]="'components.app-estado-tramites.tareas-pendientes' | translate">
					<app-tareas-pendientes/>
				</p-tabPanel>
			</p-tabView>
		</div>
	</div>
</section>
